import { useSelector } from "react-redux";
import { getCurrentUser } from "../redux/applicationUserSlice";

export default function useCurrentUserRoles(): string[] | undefined {

    const user = useSelector(getCurrentUser);

    return user?.roles;
}
